import { render, staticRenderFns } from "./DramaCategoryManagement.vue?vue&type=template&id=6213103d&scoped=true"
import script from "./DramaCategoryManagement.vue?vue&type=script&lang=js"
export * from "./DramaCategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./DramaCategoryManagement.vue?vue&type=style&index=0&id=6213103d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213103d",
  null
  
)

export default component.exports